import dayjs from 'dayjs';
import { ITimer } from '../../interface/timer';

export const isTimerFormChanged = (
  timer: ITimer | null | undefined,
  initialTimer: ITimer | null | undefined,
  isEditMode: boolean,
): boolean => {
  if (isEditMode) {
    return (
      timer?.matter?.id !== initialTimer?.matter?.id ||
      timer?.subject !== initialTimer?.subject ||
      timer?.transactionType?.id !== initialTimer?.transactionType?.id ||
      timer?.skill?.id !== initialTimer?.skill?.id ||
      dayjs(timer?.timerDate).format('YYYY-MM-DD') !==
        dayjs(initialTimer?.timerDate).format('YYYY-MM-DD')
    );
  }
  return (
    !!timer?.matter?.id ||
    !!timer?.subject ||
    !!timer?.transactionType?.id ||
    !!timer?.skill?.id ||
    dayjs(timer?.timerDate).format('YYYY-MM-DD') !==
      dayjs(initialTimer?.timerDate).format('YYYY-MM-DD')
  );
};
